import { render, staticRenderFns } from "./AppLoader.vue?vue&type=template&id=2d29cf98&scoped=true&lang=pug"
import script from "./AppLoader.vue?vue&type=script&lang=ts"
export * from "./AppLoader.vue?vue&type=script&lang=ts"
import style0 from "./AppLoader.vue?vue&type=style&index=0&id=2d29cf98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d29cf98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
